//
import { Box, styled } from '@mui/material'

export const TableHeaderItem = styled(Box)(({ theme }) => ({
  ...theme.typography.bodyMuted,
  padding: theme.spacing(1),
  textAlign: 'left',
  color: theme.palette.text.muted,
}))
